<p-toast position="top-right" styleClass="toast">
  <ng-template let-message pTemplate="message">
    <div class="flex items-center h-full w-full p-2 cursor-pointer select-none" [class]="message.contentStyleClass">
      <l-icon class="text-lWhite !text-6xl mr-2" [icon]="message.icon" />

      <div>
        <h3 class="text-lg flex text-lWhite font-bold">
          {{ message.summary }}
        </h3>
        <p class="text-lWhite">
          {{ message.detail }}
        </p>
      </div>

    </div>
  </ng-template>
</p-toast>
